// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetAppRotationProtocolData = (protocolId) => {
  const protocolImg = importImages(
    require.context("../../../../assets/images/protocols/prescriptions/app/rotation", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.app.rotation.ARMANOID.id]: {
      img: protocolImg["./armanoid.png"],
      name: "armanoid",
      video: "armanoidVideo",
      description: "armanoidDescription",
    },
    [protocols.app.rotation.DRIVING.id]: {
      img: protocolImg["./driving.png"],
      name: "driving",
      video: "drivingVideo",
      description: "drivingDescription",
    },
  };

  return protocolsData[Number(protocolId)];
};
